export default {
      id: "icon-open-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-open",
      toString: function () {
        return this.url;
      }
    }